import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGtag from 'vue-gtag'
import env from 'env'

import UserList from './pages/UserList.vue'
//import UserEdit from './pages/UserEdit.vue'
import FormList from './pages/FormList.vue'
import AnswerList from './pages/AnswerList.vue'
import FDetail from './pages/FDetail.vue'
import FList from './pages/FList.vue'
import CustomerList from './pages/CustomerList.vue'
import MessageList from './pages/MessageList.vue'
import MessageDetail from './pages/MessageDetail.vue'
import CustomerDetail from './pages/CustomerDetail.vue'
//import CustomerList from './pages/CustomerList.vue'
//import CustomerDetail from './pages/CustomerDetail.vue'
import Login from './pages/Login.vue'
//import Agreement from './pages/Agreement.vue'
//import Policy from './pages/Policy.vue'
import SystemError from './pages/errors/System.vue'


import store from './store'

// https://stackoverflow.com/questions/57837758/navigationduplicated-navigating-to-current-location-search-is-not-allowed
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        beforeEnter (to, from, next) {
            next('/forms')
        }
    },
    {
        path: '/users',
        name: 'users',
        component: UserList,
        meta: {
            title: 'users',
            auth_level: '300',
            navbar: true,
        },
    },
    {
        path: '/forms',
        name: 'forms',
        component: FormList,
        meta: {
            title: 'forms',
            auth_level: '100',
            navbar: true,
        },
    },
    {
        path: '/answers/:form_uuid/:status?',
        name: 'answers',
        component: AnswerList,
        props: true,
        meta: {
            title: 'answers',
            auth_level: '100',
            navbar: true,
        },
    },
    {
        path: '/f/:user_uuid',
        component: FList,
        props: true,
        meta: {
            title: 'f.forms',
            auth_level: '000',
            navbar: false,
        },
    },
    {
        path: '/f/:user_uuid/:form_uuid/:answer_uuid?/:email_hashed?',
//        path: '/f/:user_uuid/:form_uuid/:answer_uuid?',
        component: FDetail,
        props: true,
        meta: {
            title: 'f.form',
            auth_level: '000',
            navbar: false,
        },
    },
//    {
//        path: '/pages/:page_id/customers',
//        component: CustomerList,
//        props: true,
//    },
//    {
//        path: '/pages/:page_id/customers/:psid',
//        component: CustomerDetail,
//        props: true,
//    },
//    {
//        path: '/pages/:page_id/messages',
//        component: MessageList,
//        props: true,
//    },
//    {
//        path: '/pages/:page_id/messages/:message_id',
//        component: MessageDetail,
//        props: true,
//    },
//    {
//        path: '/pages/:page_id/messages/:message_id/:_mode',
//        component: MessageDetail,
//        props: true,
//    },
    //{
    //    path: '/sellers',
    //    component: SellerList,
    //    props: true,
    //    beforeEnter (to, from, next) {
    //        if (store.getters.auth_level >= '200') {
    //            next()
    //        } else {
    //            next('/login')
    //        }
    //    }
    //},
    //{
    //    path: '/users',
    //    component: UserList,
    //    props: true,
    //    beforeEnter (to, from, next) {
    //        if (store.getters.auth_level >= '200') {
    //            next()
    //        } else {
    //            next('/login')
    //        }
    //    }
    //},
    //{
    //    path: '/favorites',
    //    component: Favorites,
    //    beforeEnter (to, from, next) {
    //        if (store.getters.auth_check) {
    //            next()
    //        } else {
    //            next('/login')
    //        }
    //    }
    //},
    //{
    //    path: '/profile',
    //    component: Profile,
    //    beforeEnter (to, from, next) {
    //        if (store.getters.auth_check) {
    //            next()
    //        } else {
    //            next('/login')
    //        }
    //    }
    //},
    //{
    //    path: '/:mode(login|signup|newpassword)',
    //    component: Login,
    //    props: true,
    //    beforeEnter (to, from, next) {
    //        if (store.getters.auth_check) {
    //            next('/')
    //        } else {
    //            next()
    //        }
    //    }
    //},
    //{
    //    path: '/agreement',
    //    component: Agreement
    //},
    //{
    //    path: '/policy',
    //    component: Policy
    //},
    {
        path: '/500',
        component: SystemError
    }
]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve({ x: 0, y: savedPosition.y })
                }, 500)
            })
        } else {
            return { x: 0, y: 0 }
        }
    }
})

router.afterEach((to, from) => {
    store.dispatch('app/data')

    if (to.meta.auth_level > '000') {
        store.dispatch('auth/me').then(() => {
            document.title = store.getters.trans.pages[to.meta.title]
        })
    }
})

Vue.use(VueGtag, {
    config: { id: env.GOOGLE_ANALYTICS, },
}, router);

export default router

